<template>
  <div>
    <!-- ===================== MOBILE CARD LIST (< 960px) ===================== -->
    <div class="d-md-none warranties-mobile-list mt-2 px-2 pb-4">
      <v-progress-linear v-if="loading" indeterminate color="red" class="mb-2" />

      <div
        v-for="(item, index) in paginatedWarranties"
        :key="item._id"
        class="warranties-mobile-card"
        :class="{
          'warranties-mobile-card--selected': index === activeRow,
        }"
        @click="activeRow = activeRow === index ? null : index"
      >
        <div class="warranties-mobile-card__main">
          <div class="warranties-mobile-card__media">
           <qr-code v-if="item._id" :size="52" :text="item._id" />
           <button
              type="button"
              class="warranties-mobile-card__code-btn"
            >
              {{ item._id?.slice(-4) }}
            </button>
            <img
              v-if="getImg(item.language)"
              :src="getImg(item.language)"
              class="warranties-mobile-card__flag"
              alt=""
            />
            
            
          </div>

          <div class="warranties-mobile-card__info">
            <div class="warranties-mobile-card__info-top">
              <div class="font-weight-bold text-primary text-body-2">
                {{ item.title }}
              </div>
              <div v-if="item.content" class="text-caption text-grey-darken-1 mt-1">
                {{ item.content }}
              </div>

              <div class="mt-2 d-flex flex-column ga-2">
                <div class="d-flex align-center flex-wrap ga-2">
                  <span class="text-caption text-grey-darken-1">
                    {{ $t("warranties.table.expire") }}:
                  </span>
                  <v-btn color="black" variant="outlined" size="x-small" readonly @click.stop>
                    {{ formatDate(item.expire_date) }}
                  </v-btn>
                </div>
                <div class="d-flex align-center flex-wrap ga-2">
                  <span class="text-caption text-grey-darken-1">
                    {{ $t("warranties.table.return") }}:
                  </span>
                  <v-btn color="black" variant="outlined" size="x-small" readonly @click.stop>
                    {{ formatDate(item.return_before_warranty) }}
                  </v-btn>
                </div>
              </div>

              <div class="text-caption mt-2">
                {{ item.return_days / 86400 }} {{ $t("warranties.days") }}
              </div>

              <div class="mt-2 d-flex align-center">
               
              </div>
            </div>
          </div>
        </div>

        <div class="warranties-mobile-card__actions">
          <v-spacer />
          <v-btn icon variant="text" size="small" @click.stop="getDocument(item._id, item.content_document)">
            <v-icon size="20" color="grey-darken-2">mdi-format-list-bulleted</v-icon>
          </v-btn>
          <v-btn v-if="canEditDelete" icon variant="text" size="small" @click.stop="editWarranty(item)">
            <v-icon size="20" color="grey-darken-2">mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="canEditDelete" icon variant="text" size="small" @click.stop="deleteWarranty(item._id)">
            <v-icon size="20" color="grey-darken-2">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>

      <v-alert v-if="!loading && paginatedWarranties.length < 1" type="info" variant="tonal" class="mt-2">
        No data available.
      </v-alert>
    </div>
    <!-- ===================================================================== -->

    <div class="warranties-table-host pb-2">
      <v-data-table
        v-model:options="pagination"
        :headers="headers"
        :items="filteredWarranties"
        :search="searchField"
        :loading="loading"
        class="elevation-1 nowrap-headers"
        :items-per-page="pagination.itemsPerPage"
        :items-per-page-options="[
          { value: 5, title: '5' },
          { value: 10, title: '10' },
          { value: 25, title: '25' },
          { value: 50, title: '50' },
        ]"
        @update:options="updatePagination"
      >
        <template #progress>
          <v-progress-linear color="red" indeterminate />
        </template>
        <template #item="{ item, index }">
          <tr
            :class="{ tableRowColorSelected: index == activeRow }"
            class="tableRowColor"
            @click="activeRow = activeRow === index ? null : index"
          >
            <td class="text-xs">
              {{ item.title }}
            </td>
            <td class="text-xs">
              {{ item.content }}
            </td>
            <td class="text-xs">
              <v-btn variant="outlined">
                {{ formatDate(item.expire_date) }}
              </v-btn>
            </td>
            <td class="text-xs">
              {{ item.return_days / 86400 }} {{ $t("warranties.days") }}
            </td>
            <td class="text-xs">
              <v-btn variant="outlined">
                {{ formatDate(item.return_before_warranty) }}
              </v-btn>
            </td>
            <td class="text-center">
              <v-img width="20" :src="getImg(item.language)" />
              <!-- {{ item.language ? getImg(item.language): '' }} -->
            </td>
            <td class="ma-1 pt-1 pb-1">
              <v-row class="d-flex flex-column pa-3">
                <qr-code :size="50" :text="item._id" />
                <h4 class="justify-center d-flex">
                  {{ item._id.slice(item._id.length - 4, item._id.length) }}
                </h4>
              </v-row>
            </td>
            <td
              v-if="canEditDelete"
              class="justify-center"
            >
              <v-row row align-center>
                <v-icon
                  v-if="item.content_document"
                  class="mr-2 pointer"
                  color="grey-darken-2"
                  @click="getDocument(item._id, item.content_document)"
                >
                  mdi-format-list-bulleted
                </v-icon>
                <v-icon
                  class="mr-2 pointer"
                  color="grey-darken-2"
                  @click="editWarranty(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  class="pointer"
                  color="grey-darken-2"
                  @click="deleteWarranty(item._id)"
                >
                  mdi-delete
                </v-icon>
              </v-row>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert
            class="mb-0"
            :model-value="true"
            type="error"
            variant="tonal"
            border="bottom"
          >
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueQrCode from "vue-qr-generator";
import moment from "moment";
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  components: {
    "qr-code": VueQrCode,
  },
  data: () => ({
    loading: false,
    activeRow: null,
    searchField: "",
    pagination: {
      itemsPerPage: 10,
      page: 1,
      sortBy: [{ key: "expire_date", order: "desc" }],
      sortDesc: [true],
    },
    headers: [
      {
        title: "",
        sortable: false,
        key: "title",
      },
      {
        title: "",
        sortable: false,
        key: "content",
      },
      {
        text: "Expire Date: Manufacture's Warranty",
        sortable: false,
        key: "expire_date",
      },
      {
        title: "Warranty Days",
        sortable: false,
        key: "return_days",
      },
      {
        title: "Return, before activating warranty",
        sortable: false,
        key: "return_before_warranty",
      },
      {
        title: "",
        sortable: false,
        key: "language",
      },
      {
        title: "Qr Code",
        sortable: false,
        key: "qr_code",
      },
      {
        title: "",
        sortable: false,
      },
    ],
    warranties: [],
    dialogDelete: false,
    warrantyToDelete: null,
    filteredWarranties: [],
  }),
  computed: {
    canEditDelete() {
      return (
        this.$store.getters.role == "LekoAdmin" ||
        this.$store.getters.role == "LekoEmployee" ||
        this.$store.getters.role == "InstitutionAdmin" ||
        this.$store.getters.role == "SuperAdmin"
      );
    },
    paginatedWarranties() {
      const page = this.pagination.page || 1;
      const perPage = this.pagination.itemsPerPage || 10;
      const start = (page - 1) * perPage;
      return this.filteredWarranties.slice(start, start + perPage);
    },
  },
  created() {
    this.getLocale();
    this.getWarranties();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("warranties.table.title");
      this.headers[1].title = this.$t("warranties.table.content");
      this.headers[2].title = this.$t("warranties.table.expire");
      this.headers[3].title = this.$t("warranties.table.warranty_days");
      this.headers[4].title = this.$t("warranties.table.return");
      this.headers[5].title = this.$t("warranties.table.language");
      this.headers[6].title = this.$t("warranties.table.qr_code");
      this.headers[7].title = this.$t("warranties.table.actions");
    },
    search(value) {
      this.searchField = value;
      if (!value) {
        this.filteredWarranties = this.warranties;
        this.pagination.page = 1;
        return;
      }

      const term = value.toLowerCase();
      this.filteredWarranties = this.warranties.filter(
        (warr) =>
          warr.title?.toLowerCase().includes(term) ||
          warr.content?.toLowerCase().includes(term),
      );
      this.pagination.page = 1;
    },
    getDocument(id, filename) {
      getRequest("/warranty/document/", `q=${id}-${filename}`)
        .then((response) => {
          const base64EncodedStr = btoa(unescape(encodeURIComponent(response)));
          window.open(
            `data:application/pdf;base64, ${base64EncodedStr}`,
            "",
            "height=650,width=840",
          );
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    getWarranties() {
      this.loading = true;
      getRequest("/warranty/")
        .then((response) => {
          this.warranties = response.warranties;
          this.filteredWarranties = response.warranties;
          this.pagination.page = 1;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        });
    },
    updatePagination(options) {
      this.pagination = {
        ...this.pagination,
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 10,
        page: options.page ? options.page : 1,
      };
      this.activeRow = null;
    },
    editWarranty(data) {
      this.$emit("edit", data);
    },
    deleteWarranty(warrantyId) {
      this.warrantyToDelete = warrantyId;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/warranty/", `id=${this.warrantyToDelete}`)
        .then((response) => {
          if (response) {
            this.loading = false;
            this.dialogDelete = false;
            this.warrantyToDelete = null;
            this.getWarranties();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.dialogDelete = false;
          this.warrantyToDelete = null;
          this.$emit("error", error);
        });
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("D MMMM YYYY");
    },
    getImg(item) {
      switch (item) {
        case "it":
          return "https://portal.lekotech.com/img/icons/ebayIcons/italy.svg";
        case "de":
          return "https://portal.lekotech.com/img/icons/ebayIcons/germany.svg";
        case "es":
          return "https://portal.lekotech.com/img/icons/ebayIcons/spain.svg";
        case "fr":
          return "https://portal.lekotech.com/img/icons/ebayIcons/france.svg";
        case "al":
          return "https://portal.lekotech.com/img/icons/ebayIcons/albania.png";
        case "uk":
          return "https://portal.lekotech.com/img/icons/ebayIcons/united-kingdom.svg";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 959.98px) {
  .warranties-table-host :deep(.v-table__wrapper),
  .warranties-table-host :deep(.v-data-table__wrapper),
  .warranties-table-host :deep(.v-data-table__wrapper__scroll) {
    display: none !important;
  }
  .warranties-table-host :deep(.v-data-table-footer) {
    padding-inline: 12px;
  }
}
@media (min-width: 960px) {
  .warranties-mobile-list {
    display: none !important;
  }
}

.warranties-mobile-card {
  position: relative;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.warranties-mobile-card--selected {
  outline: 2px solid rgb(var(--v-theme-primary));
}
.warranties-mobile-card__main {
  display: flex;
  align-items: flex-start;
  padding: 10px 10px 6px;
  gap: 8px;
}
.warranties-mobile-card__media {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.warranties-mobile-card__flag {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}
.warranties-mobile-card__code-btn {
  min-width: 56px;
  padding: 4px 8px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  background: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  color: #424242;
  text-align: center;
}
.warranties-mobile-card__info {
  flex: 1;
  min-width: 0;
}
.warranties-mobile-card__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 4px 6px;
}
</style>
